import { render, staticRenderFns } from "./ProcedureConnections.vue?vue&type=template&id=63737298&"
import script from "./ProcedureConnections.vue?vue&type=script&lang=js&"
export * from "./ProcedureConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports